
import { setHours } from 'date-fns'
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import Select from 'react-select'
export const NoAlarmReturn = ({data, params, onChange}) => {
  const intl = useIntl()
  const [device, setDevice] = useState(
    params && params.device ? params.device : {value: '', label: 'All'}
  )
  const [hours, setHours] = useState(
    params && params.hours ? params.hours : 0
  )

  useEffect(() => {
    let newParams = {
      device: device,
      hours: hours,
    }
    onChange(newParams);
  }, [device, hours])
  return (
    <>
      <div className='row mb-6'>
        <div className='col-md-12'>
          <label htmlFor='device' className=' fw-bold fs-6'>
            {intl.formatMessage({
              id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.DEVICE_FILTER',
            })}
          </label>
          <Select
            name='device'
            options={[
              {value: '', label: 'All'},
              ...data.devices.map((cat: any) => ({
                value: cat.DevHandle + '.' + cat.ChanHandle,
                label: cat.DevDesc,
              })),
            ]}
            classNamePrefix='select'
            onChange={(selectedOption) => {
              setDevice(selectedOption)
            }}
            value={device}
          />
        </div>
      </div>
      <div className='row mb-6'>
        <div className='col-md-12'>
          <label htmlFor='device' className='required fw-bold fs-6'>
            {intl.formatMessage({
              id: 'GENERIC.PARAMETERS',
            })}
          </label>
          <div className='d-flex'>
            <div className='w-200px mt-4 me-2'>{intl.formatMessage({id:"SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ALARM_NOT_RETURNED_AFTER"})} </div>
            <input
              type='number'
              className='form-control'
              value={hours}
              onChange={(e) => setHours(e.target.value)}
            />
            <div className='mt-4 ms-2'> {intl.formatMessage({id:"GENERIC.HOURS"})}</div>
          </div>
        </div>
      </div>
    </>
  )
}
